import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { RouterModule } from '@angular/router';
import { LoaderModule, TranslateModule } from '@xref/ngx';
import { QRCodeComponent } from 'angularx-qrcode';

import { RequiredValidatorModule } from '../../../../components/required-validator/required-validator.module';
import { CountryPhoneCodesService } from '../../../../services/country-phone-codes/country-phone-codes.service';
import { TwoFactorSetupComponent } from './two-factor-setup.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        RequiredValidatorModule,
        RouterModule,
        TranslateModule,
        LoaderModule,
        MatSelectModule,
        ReactiveFormsModule,
        QRCodeComponent
    ],
    declarations: [TwoFactorSetupComponent],
    exports: [TwoFactorSetupComponent],
    providers: [
        CountryPhoneCodesService
    ]
})
export class TwoFactorSetupModule {}
